/**
 * Hinweis-Overlay für Spieler ohne Planeten.
 * Zeigt Anweisung, einen freien Planeten zu beanspruchen.
 * Wird als GameModule registriert und entfernt sich nach Claim.
 */
import type { Engine } from '../core/Engine';
import type { GameModule } from '../core/GameModule';

export class NoPlanetOverlay implements GameModule {
  readonly name = 'NoPlanetOverlay';
  private _el!: HTMLDivElement;
  private _dismissed = false;

  init(_engine: Engine): void {
    this._el = document.createElement('div');
    Object.assign(this._el.style, {
      position: 'fixed', top: '50%', left: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'rgba(0,0,0,0.85)', border: '1px solid rgba(136,204,255,0.2)',
      borderRadius: '12px', padding: 'clamp(16px,3vw,24px) clamp(20px,4vw,32px)',
      fontFamily: 'monospace', fontSize: 'clamp(13px,2.8vw,14px)', color: '#8cf',
      textAlign: 'center', zIndex: '10000', pointerEvents: 'none',
      transition: 'opacity 0.4s', lineHeight: '1.8',
    });
    this._el.innerHTML =
      'Du hast keine Planeten.<br>' +
      '<span style="color:#556;font-size:12px">' +
      'Erkunde die Karte und beanspruche einen freien Planeten.' +
      '</span>';
    document.body.appendChild(this._el);
  }

  update(): void { /* noop */ }

  dismiss(): void {
    if (this._dismissed) return;
    this._dismissed = true;
    this._el.style.opacity = '0';
    setTimeout(() => this._el.remove(), 400);
  }

  dispose(): void {
    this._el.remove();
  }
}
